import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import Quil from '../../../components/input/quil/main';
import { QuestionType } from '../../../models/enums/QuestionType';
import { ITextChoiceProps } from '../../../models/components/input-choice';
import { Notification } from '../../notification/main';

const T = Translator.create();
const _logger = Log.create('Input-Text Choice');
let _common: Common;
export class TextChoice extends Component<ITextChoiceProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <React.Fragment>
                <div
                    className="answer_type_text"
                    id={'choices_' + this.props.index}
                    ref={this.props.provided.innerRef}
                    {...this.props.provided.draggableProps}
                >
                    <div
                        className={
                            'control_group_answer w-75 survey_choose ' + (this.props.choice.isCorrect ? 'choosed-2' : '')
                        }
                        style={{ float: 'left', height: "auto" }}
                    >
                        {
                            (this.props.formik.values.questionType === QuestionType.MultipleSingle) && this.props.trueChoiseOnChange
                                ? (
                                    <label className="control control--radio">
                                        <input
                                            type="checkbox"
                                            name={'trueChoise' + this.props.index}
                                            checked={this.props.choice.isCorrect}
                                            onChange={this.props.trueChoiseOnChange.bind(
                                                this,
                                                this.props.choice.displayOrder,
                                                this.props.formik
                                            )}
                                        />
                                        <div className="control__indicator" style={{ top: -4 }} />
                                    </label>
                                )
                                : (this.props.formik.values.questionType === QuestionType.MultipleMultiple && this.props.trueChoiseOnChange
                                    ? (
                                        <label className="control control--checkbox">
                                            <input
                                                type="checkbox"
                                                name={'trueChoise' + this.props.index}
                                                checked={this.props.choice.isCorrect}
                                                onChange={this.props.trueChoiseOnChange.bind(
                                                    this,
                                                    this.props.choice.displayOrder,
                                                    this.props.formik
                                                )}
                                            />
                                            <div className="control__indicator" style={{ top: -4 }} />
                                        </label>
                                    )
                                    : ''
                                )
                        }

                        <span style={{ minWidth: 'max-content' }}>{this.props.choice.optionText})</span>
                        <Quil
                            modules={'basic'}
                            placeholder={T.t('r_gen_questionBank_choise_text_paceholder') + " *"}
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={(e: any) =>
                                this.props.choiseInputOnChange(
                                    e,
                                    this.props.choice,
                                    this.props.formik
                                )
                            }
                            value={this.props.choice.choiceText}
                            theme={'bubble'}
                            className="answer-input border-0 input-15"
                            id={'choice_' + this.props.choice.displayOrder}
                            readonly={this.props.readonly ? this.props.readonly : false}
                        />
                    </div>
                    <div
                        className="w-20"
                        style={{
                            float: 'right',
                            boxShadow: '0 1px 2px rgb(0 0 0 / 10%)',
                            borderRadius: 8
                        }}
                    >
                        <div
                            className="btn_container center"
                            style={{
                                borderRadius: 8
                            }}
                        >
                            <span className="move_btn" {...this.props.provided.dragHandleProps} onClick={() => {
                                if (this.props.formik.values.isExamQuestion) {
                                    Notification.setNotification(
                                        'error',
                                        T.t('r_api_gen_question_error_not_editable_exam_question'),
                                        'topRight'
                                    );
                                }
                            }}>
                                <i className="material-icons">open_with</i>
                            </span>
                            <span className="delete_btn" onClick={this.props.deleteChoice.bind(this, this.props.choice)}>
                                <i className="material-icons">close</i>
                            </span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}